import { CaretDown, CaretUp } from "@phosphor-icons/react";
import DropdownMenu from "../DropdownMenu";
import { Link } from "react-router-dom";
import Button from "../Button";
import ActionMenuOption, { ActionMenuItemOption } from "./ActionMenuOption";

type ActionMenuProps = {
    label: string;
    options: ActionMenuItemOption[];
};

const ActionMenu = ({ label, options }: ActionMenuProps) => {
    return (
        <DropdownMenu.Container>
            <DropdownMenu.Trigger>
                {({ open }) => (
                    <Button variant="outline">
                        {label}
                        <span className="ml-2">
                            {open ? (
                                <CaretUp weight="bold" />
                            ) : (
                                <CaretDown weight="bold" />
                            )}
                        </span>
                    </Button>
                )}
            </DropdownMenu.Trigger>
            <DropdownMenu.Items className="max-h-[15.5rem] overflow-y-auto py-1 w-[250px]">
                {options.map((option) => (
                    <DropdownMenu.Item>
                        {option.to ? (
                            <Link to={option.to}>
                                <ActionMenuOption option={option} />
                            </Link>
                        ) : (
                            <ActionMenuOption option={option} />
                        )}
                    </DropdownMenu.Item>
                ))}
            </DropdownMenu.Items>
        </DropdownMenu.Container>
    );
};

export default ActionMenu;
